import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { GenericResponseDto } from "../models/generic-response.dto";
import { CopySalesOrderRequestDto } from "../models/orders/copySalesOrderRequestDto";
import { CopySoLinesDto } from "../models/orders/copySoLinesDto";
import { GetSaleOrderDtoWIthType } from "../models/orders/getSaleOrderDtoWIthType";
import { GetSalesOrderWithLinesDto } from "../models/orders/getSalesOrderWithLinesDto";
import { CreateQuotesRequestDto } from "../models/qoutes/createQuotesRequestDto";
import { CreateSalesOrderHeaderResponseDto } from "../models/qoutes/createSalesOrderHeaderResponseDto";
import { CopyQuotesRequestDto } from "../models/qoutes/copyQuotesRequestDto";

@Injectable({
  providedIn: "root",
})
export class CopyHeaderService {
  private saleOrderManagementBaseURL =
    environment.baseUrl + "/SalesOrderManagement";
  private quoteManagementBaseURL = environment.baseUrl + "/QuotesManagement";

  constructor(private _http: HttpClient) {}

  GetAllSalesOrderWithLines(): Observable<
    GenericResponseDto<GetSalesOrderWithLinesDto[]>
  > {
    return this._http.get<GenericResponseDto<GetSalesOrderWithLinesDto[]>>(
      this.saleOrderManagementBaseURL + "/GetAllSalesOrderWithLines"
    );
  }

  addHeaderData(
    payload: CopySalesOrderRequestDto
  ): Observable<GenericResponseDto<CreateSalesOrderHeaderResponseDto>> {
    return this._http.post<
      GenericResponseDto<CreateSalesOrderHeaderResponseDto>
    >(this.saleOrderManagementBaseURL + "/CopySalesOrderHeader", payload);
  }

  addHeaderDataQuote(
    payload: CopyQuotesRequestDto
  ): Observable<GenericResponseDto<CreateQuotesRequestDto>> {
    return this._http.post<GenericResponseDto<CreateQuotesRequestDto>>(
      this.quoteManagementBaseURL + "/CopyQuotesHeaderFromOrder",
      payload
    );
  }

  getAllSalesOrderHeader(): Observable<
    GenericResponseDto<GetSaleOrderDtoWIthType[]>
  > {
    return this._http.get<GenericResponseDto<GetSaleOrderDtoWIthType[]>>(
      this.saleOrderManagementBaseURL + "/GetSaleOrderInformation"
    );
  }

  getLineAgainstSaleOrderHeader(
    payload: string
  ): Observable<GenericResponseDto<CopySoLinesDto>> {
    return this._http.get<GenericResponseDto<CopySoLinesDto>>(
      this.saleOrderManagementBaseURL +
        "/GetSalesOrderLineBySalesOrderId?salesOrderId=" +
        payload
    );
  }
}
